<template>
  <v-main>
    <v-overlay :value="$storeBourse.loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="Dialog.Informations.Model" width="auto">
      <v-card>
        <v-card-title> Informations </v-card-title>
        <v-card-text>
          <p :html="Dialog.Informations.Texte"></p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <NonAutorise v-show="!UtilisateurConnecte" />
    <v-row v-show="UtilisateurConnecte">
      <v-col cols="12">
        <v-btn
          large
          color="ecSecondary"
          @click="CreerDossier"
          v-show="!MessageErreur && Creation"
        >
          CREATION
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      v-show="!MessageErreur && UtilisateurConnecte"
      :headers="Headers"
      :items="ListeCandidatures"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.supprimer">
          <th class="text-xs-left">{{ item.anneeScolaire?.lang00 }}</th>
          <th class="text-xs-left">{{ item.etatDuDossier?.lang00 }}</th>
          <th>
            <v-icon small class="mr-2" @click="ShowItem(item)">{{
              icons.mdiEye
            }}</v-icon>
          </th>
        </tr>
      </template>
    </v-data-table>
  </v-main>
</template>
<script>
import { mdiEye } from "@mdi/js";
import NonAutorise from "@/components/PageNonAutoriseExtranet";
export default {
  name: "ListeCb",
  components: {
    NonAutorise,
  },
  data() {
    return {
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiEye,
      },
      Headers: [
        { text: "Année scolaire", align: "start", value: "name" },
        { text: "Etat du dossier", align: "start", value: "etat" },
        { text: "", align: "start", value: "action" },
      ],
      ListeCandidatures: [],
      Creation: false,
      MessageErreur: null,
      UtilisateurConnecte: true,
      Token: null,
      Dialog: {
        Informations: {
          Model: false,
          Texte: null,
        },
      },
      $storeBourse: this.$storeBourse,
    };
  },
  created() {
    document.title = "Liste Candidatures Bourses";
  },

  async mounted() {
    let token = this.$route.query.t;
    if (token) {
      token = token.replace(/\s/g, "+");
      this.token = token;
    }

    //var self = this;
    this.$storeBourse.loader = true;
    this.ChargerListe(this.token);
  },
  methods: {
    async ChargerListe(token){
      const rep = await this.$storeBourse.GetListe(token);

      if (rep) {
        if(rep.status === 200){
          // Transformation pour Vuetify
          this.ListeCandidatures = rep.data.liste;
          this.Creation = rep.data.creer;
          this.UtilisateurConnecte = true;
          this.$storeBourse.loader = false;
        }
        else{
          this.ListeCandidatures = {};
          this.UtilisateurConnecte = false;
          this.$storeBourse.loader = false;
        }
      }
    },
    CreerDossier() {
      window.location.href = "#/fichebourse?t=" + this.token;
    },
    ShowItem(item) {
      window.location.href = "#/fichebourse/" + item.id + "?t=" + this.token;
    },
  },
};
</script>
